import { APICore } from "./apiCore";

const api = new APICore();

// footerApi
function addfooterApi(params: { footer_en: string; footer_ar: string }) {
  const baseUrl = "/footer";
  return api.create(`${baseUrl}`, params);
}

function getfooterApi() {
  const baseUrl = "/footer";
  return api.get(`${baseUrl}`, {});
}

function updatefooterApi(
  id: string,
  params: { footer_en: string; footer_ar: string }
) {
  const baseUrl = `/footer/${id}`;
  return api.update(`${baseUrl}`, params);
}

function deletefooterApi(id: string) {
  const baseUrl = `/footer/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addfooterApi, getfooterApi, updatefooterApi, deletefooterApi };
